<template>
  <div>
    <BookingBreadcrumb :classes="{ completed: true }" />
    <h3 class="text-menu px-3">下記の内容で予約を確定します</h3>
    <div class="px-3 font-hiraginoSans-w3" id="customerInfoBookingMobile">
      <div class="table-therapist">
        <div class="detail-info-customer">
          <div class="row row-plan-border-mobile py-1 check-box-timeprice mb-0 p-3 border-bottom-0-mobile font-family-W3">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <span>氏名</span>
            </div>
            <div class="w-40-mobile customer-info-mobile">
              <span>{{ bookingCustomer.full_name }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>ふりがな</p>
            </div>
            <div class="w-40-mobile customer-info-mobile">
              <span>{{ bookingCustomer.full_name_kana }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>携帯電話番号</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ bookingCustomer.tel }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>メールアドレス</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ bookingCustomer.email }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>生年月日</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ bookingCustomer.birth_date }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>性別</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ genderI18n }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="font-hiraginoSans-w3">
        <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
          <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
            <p>予約日時</p>
          </div>
          <div class="customer-info-mobile">
            <span class="bookingDate">{{ bookingInfo.booking_time }}</span>
          </div>
        </div>
        <div v-if="bookingInfo.menus" class="row row-plan-border-mobile py-1 mb-0 p-3 timeprice-confirm">
          <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
            <p>メニュー</p>
          </div>
          <div class="customer-info-mobile">
            <span class="timepriceName">{{ bookingInfo.menus }}</span>
          </div>
        </div>
        <div v-if="bookingInfo.menu_options" class="row row-plan-border-mobile py-1 mb-0 p-3 timeprice-option-confirm border-top-0-mobile">
          <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
            <p>オプションメニュー</p>
          </div>
          <div class="customer-info-mobile">
            <span class="timepriceOptionName">{{ bookingInfo.menu_options }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="note-policy-cancel" v-if="bookingPermalink.cancellation_enabled && bookingPermalink.note_policy_cancel">
      <h3 class="text-menu">キャンセルポリシー</h3>
      <div class="policy-text">{{ bookingPermalink.note_policy_cancel }}</div>
    </div>
    <div class="footer-wrapper py-5">
      <div class="container">
        <div class="footer-buttons d-flex">
          <span id="backStepChooseTimeprice" class="back-step mr-2" @click="clickBackButton">戻る</span>
          <span class="btn-choose-timeprice-option next-step text-center scroll-top" @click="clickSubmitButton" >変更登録を完了する</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BookingBreadcrumb from './BookingBreadcrumb.vue'

export default {
  name: 'BookingConfirm',
  components: {
    BookingBreadcrumb
  },
  computed: {
    ...mapGetters('booking_edit', ['bookingInfo', 'bookingCustomer', 'bookingClinic', 'bookingPermalink']),
    genderI18n() {
      if (this.bookingCustomer.gender == '無回答') {
        return '回答しない';
      }
      else {
        return this.bookingCustomer.gender;
      }
       
    },
  },
  methods: {
    ...mapActions('booking_edit', ['setBookingEditStep', 'updateBooking']),
    clickBackButton() {
      this.setBookingEditStep('EditBookingCalendar');
    },
    clickSubmitButton() {
      this.updateBooking();
    }
  }
}
</script>
<style scoped>
.disabled-submit {
  pointer-events: none;
}
.note-policy-cancel {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.policy-text {
  border: 1px solid;
  border-radius: 4px;
  padding: 16px;
  white-space: pre-line;
  line-height: 16px;
  max-height: 150px;
  overflow-y: scroll;
}
</style>